import styled from "@emotion/styled/macro";
import { colors, views } from "../../../../common/styles/theme.styles";

export const EntitiesHeaderWrapper = styled.div`
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 24px;
  background: #ffffff;
  border: 1px solid ${colors.gray3};
  border-radius: 20px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
  height: 64px;
  z-index: 10;
  ${({ isThreshold }) => isThreshold ? `
    margin: 0 16px;
  ` : `
    margin-right: 0;
  `}
`;

export const HeaderTitle = styled.div`
  color: ${colors.darkGray1};
  font-family: Circular;
  font-size: 22px;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -1.32px;
  margin: 0;
  flex: 1;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  width: 36px;
  height: 36px;
  padding: 10px;
  min-width: unset;
  background: white;
  border: 1px solid #DDE3EB;
  border-radius: 8px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    border: 1px solid ${colors.darkGray1};
  }

  ${({ isDropdownMenu }) => isDropdownMenu && `
    width: auto;
    box-shadow: none;
    border: none;
    white-space: nowrap;
  `}
`;

export const DropdownMenu = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05), 0px 0px 4px rgba(0, 0, 0, 0.05);
  min-width: 160px;
  ${views.mobile} {
    min-width: 300px;
    background-color: #000;
    transform: translateY(12px);
  }
`;

export const DropdownMenuItem = styled.div`
  padding: 8px 16px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};

  &:hover {
    background-color: ${({ disabled }) => disabled ? 'transparent' : '#f5f5f5'};
  }

  ${views.mobile} {
    padding: 6px 8px 6px 16px;
    border-radius: 0px;
    color: #fff;
    &:first-of-type {
      border-bottom: 1px solid rgba(88, 93, 102, 0.50);
    }
  }
`;